
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ServicesHero from './components/ServicesHero';
import SolarSection from './components/SolarSection';
import HVACSection from './components/HVACSection';
import InsulationSection from './components/InsulationSection';
import SolarFansSection from './components/SolarFansSection';
import ProcessTimeline from './components/ProcessTimeline';
import ProjectGallery from './components/ProjectGallery';
import ConsultationCTA from './components/ConsultationCTA';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServicesHero />
      <SolarSection />
      <HVACSection />
      <InsulationSection />
      <SolarFansSection />
      <ProcessTimeline />
      <ProjectGallery />
      <ConsultationCTA />
      <Footer />
    </div>
  );
}
